import {
  getUpToDateSkillsetCoursePath,
  upToDateSkillsetCourses,
} from "../_content/up_to_date_skillset_training/const/course";
import { getImagePath } from "../../../utility/utility";
import {
  softwareQualityAssuranceCourse,
  softwareQualityAssuranceCoursePath,
} from "../_content/software_quality_assurance_training/const/course";

export type CourseCatalogItem = Readonly<{
  title: string;
  caption: string;
  description: string;
  status: string;
  to: string;
  media?: {
    kind: "image";
    src: string;
    alt: string;
  };
}>;

export type CourseCatalogCategory = Readonly<{
  id: string;
  label: string;
  description: string;
  courses: CourseCatalogItem[];
}>;

export const defaultCourseCatalogCategoryId = "vocational-training";

const upToDateSkillsetCourseTitles: Readonly<Record<string, string>> = {
  "ai-sustainable-art-design": "AI 四格漫畫創作",
  "ai-3d-printing-greener-future": "AI 與 3D 列印創作",
  "ai-mini-game-development": "AI 迷你遊戲開發",
  "ai-3d-game-development": "AI 3D 遊戲開發",
  "ai-board-game-development": "AI 桌上遊戲設計",
  "cybersecurity-introduction": "網絡安全入門",
  "ai-game-testing-human-in-the-loop": "AI 遊戲測試實務",
  "data-analysis-visualization": "AI 輔助數據分析與視覺化",
  "ai-powered-storytelling": "AI 故事創作與演說",
  "robotics-transportation": "運輸與服務機械人編程",
  "ai-music-composition": "AI 音樂創作入門",
  "ai-ethics": "AI 倫理與社會影響",
  "cross-culture-3d-music-box": "跨文化 3D 音樂盒創作",
};

export const courseCatalogCategories: CourseCatalogCategory[] = [
  {
    id: defaultCourseCatalogCategoryId,
    label: "職業導向訓練",
    description: "以就業及轉職為目標的全端開發課程。",
    courses: [
      {
        title: "全日制全端開發",
        caption: "全日制全端開發",
        description: "天程學院(TFA)專為有志投身IT行業的青年提供可負擔的職業為本資訊科技培訓，協助他們成為資訊科技專才，提升就業能力。",
        status: "已結束",
        to: "/courseDetails/fullStack",
        media: {
          kind: "image",
          src: getImagePath("Cohort1_0.jpg"),
          alt: "第一屆全日制全端開發課程相片",
        },
      },
      {
        title: "全端開發兼讀制",
        caption: "兼讀制全端開發",
        description: "晚間及星期日上課，配合工作或學習安排完成全端開發訓練。",
        status: "已結束",
        to: "/courseDetails/partTime",
      },
      {
        title: softwareQualityAssuranceCourse.title,
        caption: softwareQualityAssuranceCourse.topic,
        description: softwareQualityAssuranceCourse.content,
        status: softwareQualityAssuranceCourse.status,
        to: softwareQualityAssuranceCoursePath,
        media: softwareQualityAssuranceCourse.media,
      },
    ],
  },
  {
    id: "up-to-date-skillset-training",
    label: "最新技能培訓",
    description: "切合當前科技趨勢的短期技能課程。",
    courses: [
      ...upToDateSkillsetCourses.map((course) => ({
        title: upToDateSkillsetCourseTitles[course.id] ?? course.title,
        caption: course.topic,
        description: course.content,
        status: "最新技能",
        to: getUpToDateSkillsetCoursePath(course.id),
        media: course.media,
      })),
    ],
  },
];

export const getCourseCatalogCategoryPath = (categoryId: string) => `/courseDetails/category/${categoryId}`;

export function getCourseCatalogCategory(categoryId?: string) {
  const category = courseCatalogCategories.find((item) => item.id === categoryId);
  if (!category) return courseCatalogCategories[0];
  return category;
}
